import React from 'react'

const TheSolutionSection = () => {
  return (
    <section className='bg-black opacity-90 text-white py-10 px-6'>
      <div className='text-center mb-16'>
        <h2 className='text-5xl md:text-6xl font-bold mb-4'>The Solution</h2>
        <p className='text-xl font-light tracking-wider text-gray-400'>
          A tool that shows contextual and cookie-less advertising that doesn't hurt the user experience.
        </p>
      </div>
      <div className='grid grid-cols-1 gap-6'>
        <div className='flex py-10'>
          <article className='flex-grow w-full md:w-1/2'>
            <h3 className='text-3xl font-semibold mb-4'>Contextual parsing of content</h3>
            <p className='text-xl font-light tracking-wider text-gray-400'>
              Our servers parse textual content based on 4 signals: <span className='font-bold'>Intent</span>,{' '}
              <span className='font-bold'>Topic</span>, <span className='font-bold'>Sentiment</span> and{' '}
              <span className='font-bold'>Context</span>.
            </p>
          </article>
          <div className='flex-grow hidden md:block md:w-1/2'></div>
        </div>
        <div className='flex flex-row-reverse text-right py-10'>
          <article className='flex-grow w-full md:w-1/2'>
            <h3 className='text-3xl font-semibold mb-4'>Keywords</h3>
            <p className='text-xl font-light tracking-wider text-gray-400'>
              Our servers <span className='font-bold'></span>figure out the most valuable{' '}
              <span className='font-bold'>keyword</span>/<span className='font-bold'>phrase</span> combinations for the
              particular page, the user is most likely to associate with.
            </p>
          </article>
          <div className='flex-grow hidden md:block md:w-1/2'></div>
        </div>
        <div className='flex py-10'>
          <article className='flex-grow w-full md:w-1/2'>
            <h3 className='text-3xl font-semibold mb-4'>ptag.js</h3>
            <p className='text-xl font-light tracking-wider text-gray-400'>
              Our script <span className='font-bold'>displays</span> the ad under the most relevant{' '}
              <span className='font-bold'>keyword</span>/<span className='font-bold'>phrase</span> where the user has
              extreme control on whether he wishes to engage or not.
            </p>
          </article>
          <div className='flex-grow hidden md:block md:w-1/2'></div>
        </div>
        <div className='flex flex-row-reverse text-right py-10'>
          <article className='flex-grow w-full md:w-1/2'>
            <h3 className='text-3xl font-semibold mb-4'>No cross-site activity tracking</h3>
            <p className='text-xl font-light tracking-wider text-gray-400'>
              For Poplink ads, <span className='font-bold'>no third party cookies</span> are required. We made this
              product keeping privacy of the user in mind while ensuring that the ads are specifically tailored to the
              context of the article.
            </p>
          </article>
          <div className='flex-grow hidden md:block md:w-1/2'></div>
        </div>
      </div>
    </section>
  )
}

export default TheSolutionSection
